import type {SharedJobData} from "../../scan-model/ScanContext.tsx";
import {
    includesCursor,
    type PythonComponentDetails
} from "../../../../metl-models/jobs/component-types/pythonComponent.ts";
import type {DatabaseQueryComponent} from "../../../../metl-models/jobs/component-types/dbQuery.ts";

export interface PythonProblemIndicator {
    interpreters: string[]
    interpreterComponentCount: Record<string, number>
    usesCursor: boolean
    quickImportScan: string[]
}

export interface ScannedJobProblemIndicators {
    python?: PythonProblemIndicator
    gridExportComponents?: string[]
    usedSharedJobs?: { componentName: string, sharedJob: SharedJobData }[]
    databaseTypeCount?: Record<string, number>
    databaseTypeConnectionOptions?: Record<string, string[]>
    componentsWithStringPasswords?: string[]
}


interface ProblemHolder {
    addPython: (pythonComponent: PythonComponentDetails | undefined) => void
    addSharedJob: (componentName: string, sharedJob: SharedJobData) => void
    addGridExportComponent: (componentName: string) => void
    addDBQuery: (databaseQuery: DatabaseQueryComponent) => void
    markStringPassword: (componentName: string) => void
    resolve: () => ScannedJobProblemIndicators | undefined
}
export function problemIndicatorHolder(): ProblemHolder {
    const python: PythonProblemIndicator = {
        interpreters: [],
        interpreterComponentCount: {},
        usesCursor: false,
        quickImportScan: []
    }
    const sharedJobs: { componentName: string, sharedJob: SharedJobData }[] = []
    const gridExportComponents: string[] = []
    const driverUses: Record<string, number> = {}
    const driverConnectionPropertyKeys: Record<string, string[]> = {}
    const componentsWithStringPasswords: string[] = []
    return {
        addPython: (pythonComponent: PythonComponentDetails | undefined) => {
            if(!pythonComponent) return
            if(!python.interpreters.includes(pythonComponent.interpreter)) python.interpreters.push(pythonComponent.interpreter)
            python.interpreterComponentCount[pythonComponent.interpreter] = (python.interpreterComponentCount[pythonComponent.interpreter] || 0) + 1
            if(pythonComponent.interpreter.toLowerCase() === "jython") {
                python.usesCursor = python.usesCursor || includesCursor(pythonComponent.script)
            }
            python.quickImportScan.push(...pythonComponent.imports)
        },
        addSharedJob: (componentName: string, sharedJob: SharedJobData) => {
            sharedJobs.push({componentName, sharedJob})
        },
        addGridExportComponent: (componentName: string) => {
            gridExportComponents.push(componentName)
        },
        addDBQuery: (databaseQuery) => {
            const driverName = databaseQuery.databaseType
            if(!driverConnectionPropertyKeys[driverName]) driverConnectionPropertyKeys[driverName] = []
            databaseQuery.connectionOptionKeys.forEach(propertyKey => {
                if(!driverConnectionPropertyKeys[driverName].includes(propertyKey)) driverConnectionPropertyKeys[driverName].push(propertyKey)
            })
            driverUses[driverName] = (driverUses[driverName] || 0) + 1
        },
        markStringPassword: (componentName) => {
            if(!componentsWithStringPasswords.includes(componentName)) {
                componentsWithStringPasswords.push(componentName)
            }
        },

        resolve: () => {
            if(python.interpreters.length === 0
                && sharedJobs.length === 0
                && gridExportComponents.length === 0
                && Object.keys(driverUses).length === 0
                && componentsWithStringPasswords.length === 0
            ) {
                return undefined
            }

            return {
                python: python.interpreters.length > 0 ? python : undefined,
                databaseTypeCount: Object.keys(driverUses).length > 0 ? driverUses : undefined,
                databaseTypeConnectionOptions: Object.keys(driverConnectionPropertyKeys).length > 0 ? driverConnectionPropertyKeys : undefined,
                gridExportComponents: gridExportComponents.length > 0 ? gridExportComponents : undefined,
                usedSharedJobs: sharedJobs.length > 0 ? sharedJobs : undefined,
                componentsWithStringPasswords: componentsWithStringPasswords.length > 0 ? componentsWithStringPasswords : undefined
            }
        }
    }
}